/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import {NgxPaginationModule} from 'ngx-pagination';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { CodeInputModule } from 'angular-code-input';

import { TokenInterceptor } from '../interceptors/token.interceptor';
import { RouterModule } from '@angular/router';
import { AdminRoutingModule } from './admin-routing.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicStorageModule } from '@ionic/storage-angular';

// pages
import { LoginPage } from './pages/login/login.page';
import { ManagePlayroomsPage } from './pages/manage-playrooms/manage-playrooms.page';
import { ManageUsersPage } from './pages/manage-users/manage-users.page';
import { ManageVisitorsPage } from './pages/manage-visitors/manage-visitors.page';
import { AdminSettingsPage } from './pages/admin-settings/admin-settings.page';
import { VisitsPage } from './pages/visits/visits.page';
import { ManageRampsPage } from './pages/manage-ramps/manage-ramps.page';
import { KarticaVisitoraPage } from './pages/kartica-visitora/kartica-visitora.page';
import { ManageBirthdayZonesPage } from './pages/manage-birthday-zones/manage-birthday-zones.page';
// components
import { StartLayoutComponent } from './components/start-layout/start-layout.component';
import { HeaderComponent } from './components/header/header.component';
import { AddUserModalComponent } from './components/modals/add-user-modal/add-user-modal.component';
import { DeleteUserModalComponent } from './components/modals/delete-user-modal/delete-user-modal.component';
import { EditUserModalComponent } from './components/modals/edit-user-modal/edit-user-modal.component';
import { AddPlayroomModalComponent } from './components/modals/add-playroom-modal/add-playroom-modal.component';
import { EditPlayroomModalComponent } from './components/modals/edit-playroom-modal/edit-playroom-modal.component';
import { DeletePlayroomModalComponent } from './components/modals/delete-playroom-modal/delete-playroom-modal.component';
import { AddVisitModalComponent } from './components/modals/add-visit-modal/add-visit-modal.component';
import { EditVisitModalComponent } from './components/modals/edit-visit-modal/edit-visit-modal.component';
import { DeleteVisitorModalComponent } from './components/modals/delete-visitor-modal/delete-visitor-modal.component';
import { ManageVisitsComponent } from './pages/manage-visits/manage-visits.component';
import { AutofocusDirective } from '../_directive/directive/autofocusDirective';
import { HasRoleDirective } from '../_directive/directive/hasRoleDirective';
import { BlockedStatusComponent } from './components/modals/blocked-status/blocked-status.component';
import { SurchargeModalComponent } from './components/modals/surcharge-modal/surcharge-modal.component';
import { QRCodeModule } from 'angularx-qrcode';
import { AddRampModalComponent } from './components/modals/add-ramp-modal/add-ramp-modal.component';
import { EditRampModalComponent } from './components/modals/edit-ramp-modal/edit-ramp-modal.component';
import { DeleteRampModalComponent } from './components/modals/delete-ramp-modal/delete-ramp-modal.component';
import { AdminComponent } from './admin.component';
import { ActivityLogComponent } from './activity-log.component';
import { AddStaffcardModalComponent } from './components/modals/add-staffcard-modal/add-staffcard-modal/add-staffcard-modal.component';
import { EditStaffcardModalComponent } from './components/modals/edit-staffcard-modal/edit-staffcard-modal/edit-staffcard-modal.component';
import { DeleteStaffcardModalComponent } from './components/modals/delete-staffcard-modal/delete-staffcard-modal/delete-staffcard-modal.component';
import { ManageStaffcardsComponent } from './pages/manage-staffcards/manage-staffcards/manage-staffcards.component';
import { EditVisitorModalComponent } from './components/modals/edit-visitor-modal/edit-visitor-modal.component';
import { ViewQrCodeComponent } from './components/modals/view-qr-code/view-qr-code.component';
import { AddBirthdayZoneModalComponent } from './components/modals/add-birthday-zone-modal/add-birthday-zone-modal.component';
import { EditBirthdayZoneModalComponent } from './components/modals/edit-birthday-zone-modal/edit-birthday-zone-modal.component';
import { DeleteZoneModalComponent } from './components/modals/delete-zone-modal/delete-zone-modal.component';
import { TimeSlotConfigurationComponent } from './pages/time-slot-configuration/time-slot-configuration.component';
import { BirthdateBookingComponent } from './pages/birthdate-booking/birthdate-booking.component';
import { BirthdayListPage } from './pages/birthday-list/birthday-list.page';
import { EditBirthdayComponent } from './components/modals/edit-birthday/edit-birthday.component';
import { BirthdayDeleteModalComponent } from './components/modals/birthday-delete-modal/birthday-delete-modal.component';
import { DismissBirthdayModalComponent } from './components/modals/dismiss-birthday-modal/dismiss-birthday-modal.component';
import { CallListComponent } from './pages/call-list/call-list.component';
import { VisitorsCardFromBookingComponent } from './pages/visitors-card-from-booking/visitors-card-from-booking.component';
import { BirthdayDetailsComponent } from './pages/birthday-details/birthday-details.component';
import { BirthdayEditFormFromCalendarComponent } from './pages/birthday-edit-form-from-calendar/birthday-edit-form-from-calendar.component';
import { BirthdayTableComponent } from './shared/birthday-table/birthday-table.component';
import { CalllistTabaleComponent } from './shared/calllist-tabale/calllist-tabale.component';
import { TimeSpanPipe } from './pipes/time-span.pipe';
import { SekondsToTimePipe } from './pipes/sekonds-to-time.pipe';
import { PonovljeniRodjendaniReportComponent } from './reports/ponovljeni-rodjendani-report/ponovljeni-rodjendani-report.component';
import { ProsecanUzrastDetetaIgraonicaIzvestajComponent } from './reports/prosecan-uzrast-deteta-igraonica-izvestaj/prosecan-uzrast-deteta-igraonica-izvestaj.component';
import { ListaPozivaOperateriReportComponent } from './reports/lista-poziva-operateri-report/lista-poziva-operateri-report.component';
import { JedinstveniPoziviReportComponent } from './reports/jedinstveni-pozivi-report/jedinstveni-pozivi-report.component';
import { ZakazaniRodjendaniOperateriReportComponent } from './reports/zakazani-rodjendani-operateri-report/zakazani-rodjendani-operateri-report.component';
import { DoplatneKarteReportComponent } from './reports/doplatne-karte-report/doplatne-karte-report.component';



export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AdminComponent, LoginPage, ManagePlayroomsPage, VisitsPage, ManageUsersPage, ManageVisitorsPage, AdminSettingsPage,
    StartLayoutComponent, HeaderComponent,ManageRampsPage,ManageStaffcardsComponent,
    AddUserModalComponent, DeleteUserModalComponent, EditUserModalComponent, DeleteVisitorModalComponent,
    AddPlayroomModalComponent, EditPlayroomModalComponent, DeletePlayroomModalComponent, AddVisitModalComponent, EditVisitModalComponent,
    ManageVisitsComponent, HasRoleDirective, AutofocusDirective, BlockedStatusComponent,SurchargeModalComponent,AddRampModalComponent,EditRampModalComponent,DeleteRampModalComponent, AdminComponent,AddStaffcardModalComponent,EditStaffcardModalComponent,DeleteStaffcardModalComponent,EditVisitorModalComponent,
    ViewQrCodeComponent,KarticaVisitoraPage,
    ManageBirthdayZonesPage,AddBirthdayZoneModalComponent,EditBirthdayZoneModalComponent,DeleteZoneModalComponent,
    TimeSlotConfigurationComponent, BirthdateBookingComponent,
   BirthdayListPage,EditBirthdayComponent,BirthdayDeleteModalComponent,DismissBirthdayModalComponent,
  CallListComponent,
  VisitorsCardFromBookingComponent, 
 BirthdayDetailsComponent,BirthdayTableComponent,CalllistTabaleComponent,
  ActivityLogComponent,
  BirthdayEditFormFromCalendarComponent, 
  TimeSpanPipe,
  SekondsToTimePipe,PonovljeniRodjendaniReportComponent,ProsecanUzrastDetetaIgraonicaIzvestajComponent,
  ListaPozivaOperateriReportComponent,
  JedinstveniPoziviReportComponent,
  ZakazaniRodjendaniOperateriReportComponent,
  DoplatneKarteReportComponent
   
    
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule,
    RouterModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    IonicStorageModule.forRoot()
  ]
})
export class AdminModule {}
